/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMttCartIcon containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum cartLinesSortOrder {
    ascending = 'ascending',
    descending = 'descending'
}

export interface IMttCartIconConfig extends Msdyn365.IModuleConfig {
    imageSettings?: Msdyn365.IImageSettings;
    enableHoverCart?: boolean;
    cartLinesSortOrder?: cartLinesSortOrder;
    isAnonymousCheckout?: boolean;
    clientRender?: boolean;
}

export interface IMttCartIconResources {
    continueShoppingButtonTitle: string;
    subTotalMessage: string;
    item: string;
    items: string;
    emptyPrice: string;
    goToCartButtonTitle: string;
    totalPriceFormatString: string;
    guestCheckoutButtonTitle: string;
    checkoutButtonTitle: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeConfiguration: string;
    quantityDisplayText: string;
    removeCartButtonText: string;
    cartLabel: string;
    cartQtyLabel: string;
    flyoutTitle: string;
    salesAgreementPricePrompt: string;
    shippingText: string;
    checkoutBlockedDueToUnavailableFundsTitle: string;
    checkoutBlockedDueToUnavailableFundsMessage: string;
    outOfStockErrorMessage: string;
    eVoucherValidationErrorMessageHeader: string;
    eVoucherValidationErrorMessage: string;
    eVoucherIsNotAllowedForGuestErrorMessage: string;
    eVoucherIsMixedWithRegularItemsErrorMessage: string;
    paymentTermValidationErrorMessageHeader: string;
    paymentTermValidationErrorMessage: string;
    paymentTermValidationGroupTermLabel: string;
    paymentTermValidationNoCategoryLabel: string;
    paymentTermValidationNotDefinedLabel: string;
}

export interface IMttCartIconProps<T> extends Msdyn365.IModule<T> {
    resources: IMttCartIconResources;
    config: IMttCartIconConfig;
    slots: {
        emptyCart: React.ReactNode[];
        promoContentItem: React.ReactNode[];
    };
}
